import React from 'react'

export default function Botones( {index , botonBorrar}) {
  return (
    <>
        <div className='row mt-5'>
            <div className='col-12'>

                <button onClick={() => botonBorrar(index)} className="btn btn-primary mt-3 button-3">
                    Borrar
                </button>

            </div>

        </div>
    </>
  )
}
